import { main } from '@wxu/html-rehydrator';
import { modules } from './modules';

main({
  modules,
});
